import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleScrollTo = (targetPath, scrollId, e) => {
    if (location.pathname === targetPath) {
      e?.preventDefault();
      // Scroll to section on same page
      const section = document.getElementById(scrollId);
      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    } else {
      e?.preventDefault();
      navigate(targetPath, { state: { scrollTo: scrollId } });
    }
  };

  return (
    <div className="bg-[#1a1d29] text-white py-6 relative">
      <div className="4xl:max-w-[100rem] 4xl:mx-auto relative">
        {/* Main Content */}
        <div className="flex flex-col lg:flex-row gap-20 items-center lg:items-start justify-center lg:justify-start pt-16 pb-12 px-6 md:px-16">
          {/* Column 1: CreatorShield */}
          <div className="flex flex-col gap-4 w-full lg:w-[336px] text-center lg:text-left">
            <h3 className="font-semibold text-xl">CreatorShield</h3>
            <p className="text-lg leading-[30px] font-normal">
              Protecting creators and helping them claim what's rightfully
              theirs since day one.
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-20 w-full lg:justify-end items-center lg:items-start">
            {/* Column 2: For Creators */}
            <div className="flex flex-col gap-[28px] lg:gap-7 w-full lg:w-[230px] text-center lg:text-left">
              <h3 className="font-semibold text-xl">For Creators</h3>
              <div className="flex flex-col gap-4">
                <Link
                  to="/esign"
                  className="text-lg leading-[30px] font-normal hover:text-white/80 transition-colors"
                >
                  Get Started
                </Link>
                <Link
                  to="/"
                  onClick={(e) => handleScrollTo("/", "how-it-works", e)}
                  className="text-lg leading-[30px] font-normal hover:text-white/80 transition-colors"
                >
                  How It Works
                </Link>
                <Link
                  to="/success-stories"
                  className="text-lg leading-[30px] font-normal hover:text-white/80 transition-colors"
                >
                  Success Stories
                </Link>
                <Link
                  to="/"
                  onClick={(e) => handleScrollTo("/", "for-media-companies", e)}
                  className="text-lg leading-[30px] font-normal hover:text-white/80 transition-colors"
                >
                  For Media Companies
                </Link>
              </div>
            </div>

            {/* Column 3: CreatorShield Live */}
            <div className="flex flex-col gap-[28px] lg:gap-7 w-full lg:w-[230px] text-center lg:text-left">
              <h3 className="font-semibold text-xl">CreatorShield Live</h3>
              <div className="flex flex-col gap-4">
                <Link
                  to="/esign"
                  className="text-lg leading-[30px] font-normal hover:text-white/80 transition-colors"
                >
                  Get Protected
                </Link>
                <Link
                  to="/live"
                  onClick={(e) => handleScrollTo("/live", "what-we-protect", e)}
                  className="text-lg leading-[30px] font-normal hover:text-white/80 transition-colors"
                >
                  What We Protect
                </Link>
                <Link
                  to="/live"
                  onClick={(e) => handleScrollTo("/live", "live-benefits", e)}
                  className="text-lg leading-[30px] font-normal hover:text-white/80 transition-colors"
                >
                  CreatorShield Live Benefits
                </Link>
                <Link
                  to="/live"
                  onClick={(e) =>
                    handleScrollTo("/live", "platform-coverage", e)
                  }
                  className="text-lg leading-[30px] font-normal hover:text-white/80 transition-colors"
                >
                  Platform Coverage
                </Link>
              </div>
            </div>

            {/* Column 4: Resources */}
            <div className="flex flex-col gap-[28px] lg:gap-7 w-full lg:w-[230px] text-center lg:text-left">
              <h3 className="font-semibold text-xl">Resources</h3>
              <div className="flex flex-col gap-4">
                <Link
                  to="/faq"
                  className="text-lg leading-[30px] font-normal hover:text-white/80 transition-colors"
                >
                  Frequently Asked Questions
                </Link>
                <Link
                  to="/contact-us"
                  className="text-lg leading-[30px] font-normal hover:text-white/80 transition-colors"
                >
                  Contact Us
                </Link>
                <Link
                  to="/contact-us"
                  className="text-lg leading-[30px] font-normal hover:text-white/80 transition-colors"
                >
                  Support
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Separator Line */}
        <div className="border-t border-white/20 my-8"></div>

        {/* Copyright */}
        <div className="text-center pt-5 pb-8">
          <p className="text-lg leading-[30px] font-normal">
            © 2026 CreatorShield. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
